var _line, _g, _rect, _rect2, _rect3, _line2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoriesPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 88,
    viewBox: "0 0 110 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.18557e-8,
    x2: 0.499998,
    y2: 48,
    stroke: "#333333",
    strokeDasharray: "1 6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_907_8329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4568 83.4388L57.3148 83.4388C63.6575 83.4388 43.1917 75.2418 56.0462 73.9825C72.1144 72.4084 78.0342 80.6742 86.4911 70.9912",
    stroke: "url(#paint0_linear_907_8329)",
    strokeWidth: 0.572093
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.272 74.7071L33.7235 75.5452L35.1751 76.3832C34.7434 77.1311 33.8665 78.9181 33.8128 80.0837L33.6777 80.1721C32.2464 81.1085 29.4585 82.9324 29.0821 83.5843C29.4585 82.9324 29.6442 79.6055 29.7395 77.8979L29.7485 77.7371C30.7311 77.1079 31.8402 75.4549 32.272 74.7071Z",
    fill: "#EA5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8055 71.604L32.3483 74.128L35.6385 76.0276L37.0957 73.5037L33.8055 71.604Z",
    fill: "#EA5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0753 71.1367L35.7204 72.0865L37.3656 73.0363L42.4927 64.1558L40.8476 63.206L39.2025 62.2562L34.0753 71.1367Z",
    fill: "#EA5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8917 61.4536L43.3432 64.0236L59.0484 36.8214L54.5969 34.2513L38.8917 61.4536Z",
    fill: "#EA5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6732 33.6722L59.5118 36.4657L60.969 33.9418L56.1304 31.1483L54.6732 33.6722Z",
    fill: "#EA5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.497 30.7367L58.9163 32.1335L61.1421 33.4185L74.0948 10.9837L71.8691 9.69867L69.4498 8.3019L56.497 30.7367Z",
    fill: "#EA5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7736 7.74103L72.1929 9.1378L74.4186 10.4228L75.7567 8.3287C76.016 7.73058 76.1669 6.32202 74.3089 5.2493C72.4509 4.17658 71.3065 5.01153 70.9182 5.53515L69.7736 7.74103Z",
    fill: "#EA5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7799 28.9059C56.5065 18.6523 65.5169 8.85637 69.2805 6.58384C62.5752 13.0575 60.9095 18.8263 59.9139 21.2428C58.6279 24.3641 57.7849 26.4948 56.7799 28.9059Z",
    fill: "#EA5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7736 7.74103L72.1929 9.1378L74.4186 10.4228L75.7567 8.32869C76.016 7.73058 76.1669 6.32202 74.3088 5.2493C72.4508 4.17658 71.3065 5.01153 70.9181 5.53515L69.7736 7.74103Z",
    fill: "#EA5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6731 33.6722L59.5117 36.4658L60.9689 33.9419L56.1303 31.1483L54.6731 33.6722Z",
    fill: "#F7F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8051 71.604L32.3479 74.1279L35.6381 76.0275L37.0953 73.5036L33.8051 71.604Z",
    fill: "#F7F0F0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 2.55029,
    width: 7,
    height: 7,
    transform: "rotate(45 23.5 2.55029)",
    fill: "#F7F0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 41.7573,
    width: 6,
    height: 6,
    transform: "rotate(45 86 41.7573)",
    fill: "#F7F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 67.7573,
    width: 6,
    height: 6,
    transform: "rotate(45 11 67.7573)",
    fill: "#F7F0F0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 109.5,
    y1: 40,
    x2: 109.5,
    y2: 88,
    stroke: "#333333",
    strokeDasharray: "1 6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_907_8329",
    x1: 53.932,
    y1: 83.088,
    x2: 88.1826,
    y2: 69.5569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_907_8329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white",
    transform: "translate(14 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesPen);
export default __webpack_public_path__ + "static/media/categoriesPen.80cff06e18da954b5e1f0f3289658ca3.svg";
export { ForwardRef as ReactComponent };